import style from './EmptyTransactionList.css';
import NoTransaction from '../../../assets/images/no-transactions.webp';
import useTranslation from '../../../localization/i18n.context';
import { renderIf } from '../../../utils/render.utils';

export default function EmptyTransactionList({
  className = '',
  showSubtitle = false,
  ...props
}) {
  const { t } = useTranslation();
  return (
    <div className={`${className} ${style['no-transactions']}`} {...props}>
      <img src={NoTransaction} width={120} height={120} />

      <div className={style.text}>
        <h3>{t("You don't have any transaction yet")}</h3>
        {renderIf(
          showSubtitle,
          <span>{t('Top up your card and start shopping!')}</span>,
        )}
      </div>
    </div>
  );
}
